export default __webpack_public_path__ + "static/media/rotaract-1.74b84a7d.jpeg";